module.exports = __webpack_public_path__ + "img/52932022.22c6b314.png";